"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromLoginResult = void 0;
function fromLoginResult(result, iat) {
    return {
        accessToken: result.accessToken,
        aws: result.aws,
        expiresAt: iat + result.expires * 1000,
        sub: result.sub,
        refreshToken: result.refreshToken,
        user: result.user,
    };
}
exports.fromLoginResult = fromLoginResult;
//# sourceMappingURL=ApiCredentialService.js.map